<template>
    <div class="h-piece">
        <div class="h-pieceIn2 n-xiao">
            <div class="h-pieceTitle2 " style="margin-left:10px">
                <h1>收货单位</h1>
            </div>
            <div class="h-pieceCon2">
                <div class="h-formLine">
                    <el-form :model="addr" label-position="right" :inline="true"
                             class="demo-ruleForm h-formbLine">
                        <el-form-item label="单位名称" class="h-elformWrap-2">
                            <el-input v-model="addr.deptName" readonly></el-input>
                        </el-form-item>
                        <el-form-item label="渠道" class="h-elformWrap-2">
                            <brselect
                                    style="width:2rem;"
                                    category="channel_classification"
                                    :v="addr.deptSourceChannel2"
                                    disabled
                                    v-model="addr.deptSourceChannel2"
                                    clearable
                                    placeholder="--请选择--">
                            </brselect>
                        </el-form-item>
                        <el-form-item label="用户分类" class="h-elformWrap-2">
                          <el-input v-model="addr.schoolTypeName2" readonly></el-input>
                        </el-form-item>
                        <el-form-item label="省" class="h-elformWrap-2">
                            <el-input v-model="addr.province" readonly></el-input>
                        </el-form-item>
                        <el-form-item label="市" class="h-elformWrap-2">
                            <el-input v-model="addr.city" readonly></el-input>
                        </el-form-item>
                        <el-form-item label="区" class="h-elformWrap-2">
                            <el-input v-model="addr.area" readonly></el-input>
                        </el-form-item>
                        <el-form-item label="上级" class="h-elformWrap-2">
                            <el-input v-model="addr.parentName" readonly></el-input>
                        </el-form-item>
                        <el-form-item label="详细地址" class="h-elformWrap-2">
                            <el-input v-model="addr.address" readonly></el-input>
                        </el-form-item>
                        <el-form-item label="是否正常" class="h-elformWrap-2">
                            <el-input v-model="addr.sfzc" readonly></el-input>
                        </el-form-item>
                        <el-form-item label="数据来源" class="h-elformWrap-2">
                            <el-input v-model="addr.dataSourceName" readonly></el-input>
                        </el-form-item>
                        <el-form-item label="曾用名" class="h-elformWrap-2">
                          <el-input v-model="addr.deptNameLog" readonly></el-input>
                        </el-form-item>
                      <el-form-item label="地标性" class="h-elformWrap-2" prop="landmark" label-width="100">
                        <el-select v-model="addr.landmark" placeholder="请选择" disabled>
                          <el-option label="KA" value="KA"></el-option>
                          <el-option label="省级" value="省级"></el-option>
                          <el-option label="地市级" value="地市级"></el-option>
                          <el-option label="区县级及以下" value="区县级及以下"></el-option>
                        </el-select>
                      </el-form-item>
                    </el-form>
                </div>
            </div>
            <div class="h-table h-mrt30    bbbb" v-if="this.taskstatus == '0'">
                <viewhistory :visible.sync="showhistory" v-if="showhistory" :id="instid"/>
                <div class="h-pieceTitle2 hang">
                    <h1 class="h1">审批意见</h1>
                    <el-form :model="form" label-position="right" :inline="true"
                             class="demo-ruleForm h-formbLine ">
                        <el-form-item label="审批意见" class="h-elformWrap-2 " style="margin:20px" :required="true">
                            <el-input v-model="form.spyj" placeholder="请输入"
                            ></el-input>
                        </el-form-item>
                    </el-form>
                </div>
            </div>
            <div class="anniu" v-if="this.taskstatus == '0' ">
                <el-button class="el-button h-btn h-bBtn h-bgwhite el-button--default" @click="saveOrSubmit(0)">返回</el-button>
                <el-button class="el-button h-btn h-bBtn h-bgred el-button--default"
                           @click="saveOrSubmit(2)">驳回
                </el-button>
                <el-button class="el-button h-btn h-bBtn h-bggreen el-button--default" @click="saveOrSubmit(1)">通过
                </el-button>
                <el-button class="el-button h-btn el-button--default"
                           @click="viewpress">审批跟踪
                </el-button>
            </div>
            <div class="anniu" v-if="this.taskstatus == '1'">
                <el-button class="el-button h-btn h-bBtn h-bgwhite el-button--default" @click="saveOrSubmit(0)">返回</el-button>
                <el-button class="el-button h-btn el-button--default"
                           @click="viewpress">审批跟踪
                </el-button>
            </div>
        </div>
    </div>
</template>

<script>
    import ss from '../../api/SystemService'

    props:["taskId","instid","taskstatus"]

    export default {
        data() {
            return {
                taskstatus: null,
                addr: {
                    deptName: '',
                    deptType: '',
                    leader: '',
                    phone: '',
                    email: '',
                    province: '',
                    city: '',
                    area: '',
                    spyj:'',
                    address: '',
                    insid: '' ,
                    landmark:'',
                    taskId: '',
                    deptSourceChannel:'',
                    schoolType:'',
                    sfzc:'',
                  //渠道版本2.0
                  deptSourceChannel2:'',
                  //用户分类版本2.0
                  schoolType2:'',
                  schoolTypeName2:'',
                },
                form: {
                    spyj:''
                },
                showhistory: false,
                id: null,
            }
        },
        methods: {
            saveOrSubmit(v) {
                if (v == '0') {
                    if (this.$route.query.f == '1') {
                        this.$router.back();
                        return;
                    }
                    this.$emit('refreshSelf',{close:true,refresh:false});
                    return;
                }else if(v == '1'){
                    this.addr.taskId = this.$route.query.taskid;
                    this.addr.spyj = this.form.spyj;
                    var data = this.addr
                    ss.nxAddress.approveAddress(data).then(rd => {
                        this.$msg.alerts("提交成功！",()=>{
                            //刷新右上角的代办个数
                            this.$store.dispatch("searchTasktotal")
                            this.$router.go(-1);
                        })
                    })
                }else if(v == '2'){
                    if (!this.form.spyj) {
                        this.$msg.msge("驳回必须输入审批意见！");
                        return;
                    }
                    this.addr.spyj = this.form.spyj;
                    this.addr.taskId = this.$route.query.taskid;
                    var data = this.addr
                    ss.nxAddress.rejectAddress(data).then(rd => {
                        this.$msg.alerts("提交成功！",()=>{
                            //刷新右上角的代办个数
                            this.$store.dispatch("searchTasktotal")
                            this.$router.go(-1);
                        })
                    })
                }
            },
            viewpress(r) {
                this.showhistory = true;
            },
            selectAddress(id) {
                var addrId = id;
                ss.nxAddress.selectByInstid(addrId).then(rd => {
                    console.log("rddddd",rd)
                    this.addr = rd.msg;
                })
            },
        },
        created() {
            /*this.instid = this.instid;
            this.taskstatus = this.taskstatus;*/
            if (this.$route.query.taskstatus == 0) {
                this.taskstatus = '0'
            }
            this.instid = this.$route.query.instid
            this.id = this.$route.query.taskid;
            this.addr.taskId = this.$route.query.taskid;
            this.selectAddress(this.$route.query.instid)
        },
    }
</script>
<style scoped>
    .n-xiao .h-formbLine .h-elformWrap-2,
    .n-two .h-formbLine .h-elformWrap-2 {
        width: 33.333%;
    }
    .anniu {
        display: flex;
        justify-content: center;
        align-items: center;
        margin-top: 0.3rem;
    }
</style>
